import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ArrowUpIcon extends BaseIcon {
  getChildren = () => [<path transform="rotate(-180 11.995000839233398,12.289999961853027)" fill={ this.getColor() }
                             d='M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7c-.39-.39-.39-1.02 0-1.41.39-.38 1.03-.39 1.42 0z'/>]
  getViewBox = () => '0 0 24 24'
}
